export const AddFileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M20 25.7V1M20 1L25.7 7.65M20 1L14.3 7.65"
      stroke="url(#paint0_linear_1245_105694)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4 38.9999H27.6C32.9732 38.9999 35.6617 38.9999 37.3299 37.3317C39 35.6597 39 32.975 39 27.5999V25.6999C39 20.3267 39 17.6401 37.3299 15.97C35.8707 14.5108 33.6325 14.3265 29.5 14.3037M10.5 14.3037C6.3675 14.3265 4.1293 14.5108 2.6701 15.97C1 17.6401 1 20.3267 1 25.6999V27.5999C1 32.975 1 35.6616 2.6701 37.3317C3.2401 37.9017 3.9279 38.276 4.8 38.523"
      stroke="url(#paint1_linear_1245_105694)"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1245_105694"
        x1="14.0657"
        y1="13.35"
        x2="23.674"
        y2="8.93796"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1245_105694"
        x1="0.219178"
        y1="26.6518"
        x2="11.8177"
        y2="8.89582"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
    </defs>
  </svg>
);
